import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "../SpaceDialogAction";

const DialogStudentAddedSuccessfully = ({
	dialog, studentsSelectedToUse, space
}) => {
	const student = studentsSelectedToUse[0];
	return (
		<SpaceDialogAction
			dialog={dialog}
			title={`Se agregó a ${student.id} (${student.name})
			de la reserva del espacio ${space.name}`}
			content="Podrás visualizarlo nuevamente en el listado de alumnos.">
			<CustomButton
				width="120px"
				text="Cerrar"
				onClick={dialog.hide} />
		</SpaceDialogAction>
	);
}

export default DialogStudentAddedSuccessfully;